<template>
    <base-frame :isMe="isMe">
      <div slot="chatmessage" class="msg-loading">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </base-frame>

</template>

<script>
import BaseFrame from './BaseFrame'

export default {
  name: 'tpl-loading',
  components: {
    BaseFrame
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  }
}
</script>

<style>
.msg-loading {
  display: inline-block;
  box-sizing: content-box;
}

.msg-loading>div{
  background-color: #ccc;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-name: scale;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(.2,.68,.18,1.08);
  /* animation-timing-function: ease; */
}

.msg-loading>div:nth-child(1) {
  animation-delay: -.24s;
}

.msg-loading>div:nth-child(2) {
  animation-delay: -.12s;
}

.msg-loading>div:nth-child(3) {
  animation-delay: 0s;
}

@keyframes scale {
  0% {
      -ms-transform: scale(1);
      -webkit-transform: scale(1);
      transform: scale(1);
  }

  50% {
      -ms-transform: scale(1);
      -webkit-transform: scale(.3);
      transform: scale(.3);
  }

  100% {
      -ms-transform: scale(1);
      -webkit-transform: scale(1);
      transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/TplLoading.vue